/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { MedicalCondition } from '../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    medicalCondition: MedicalCondition
}

const UpdatedInCell: FC<Props> = ({ medicalCondition }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {medicalCondition.updatedAt ? formatDateTime(medicalCondition.updatedAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.updatedAt ? franchise.updatedAt.toString() : 'N/A'}</span> */}
    </div>
)

export { UpdatedInCell }
